// 鉄瓶LP - JavaScript（PRODUCTS_DATA / MAKERS_DATA / PATTERNS_DATA + interactive logic）
// 自動生成日時: 2026-05-10T01:58:47.941Z
// 生成元: scripts/_phase3_generate_data_js.mjs
// 入力:
//   - outputs/_state_master.json
//   - outputs/_phase3_asset_map.json
//   - scripts/_phase3_lp_logic.js
// 注意: このファイルを直接編集しないでください。再生成は次のコマンドを実行：
//   node scripts/_phase3_generate_data_js.mjs

// ===== DATA SECTION START (auto-generated by scripts/_phase3_generate_data_js.mjs - DO NOT EDIT) =====

const LP_GENERATED_AT = "2026-05-10T01:58:47.935Z";

const PRODUCTS_DATA = {
  "2": {
    "no": 2,
    "title": "★薫山工房（南部鉄器協同組合）砂鉄鉄瓶 布団型 亀甲 1.6L 伝統工芸士 佐々木 和夫 作 【0035324】",
    "short_title": "薫山工房 砂鉄鉄瓶 布団型 亀甲 1.6L",
    "handle": "0035324",
    "public_url": "https://iwatekensan-shop.com/products/0035324",
    "price": 220000,
    "price_display": "¥220,000",
    "maker_code": "kunzan",
    "maker_display_name": "薫山工房",
    "artisan_name": "佐々木 和夫",
    "capacity": "1.6L",
    "capacity_l": 1.6,
    "shape_pattern": "布団型_亀甲",
    "patterns": [
      "亀甲"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No02-kunzan-1x1-product-front-right-01.webp?v=1778315427",
        "alt": "No02 薫山工房 布団型 亀甲 1.6L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No02-kunzan-1x1-product-front-left-01.webp?v=1778315428",
        "alt": "No02 薫山工房 布団型 亀甲 1.6L 正面・左向き"
      }
    }
  },
  "3": {
    "no": 3,
    "title": "★岩鋳（南部鉄器協同組合）鉄瓶 23型南部型アラレ 1.9L 伝統工芸士 清茂 作 【0035325】",
    "short_title": "岩鋳 鉄瓶 23型南部型アラレ 1.9L",
    "handle": "0035325",
    "public_url": "https://iwatekensan-shop.com/products/0035325",
    "price": 121000,
    "price_display": "¥121,000",
    "maker_code": "seimo",
    "maker_display_name": "岩鋳",
    "artisan_name": "清茂",
    "capacity": "1.9L",
    "capacity_l": 1.9,
    "shape_pattern": "23型 南部型_アラレ",
    "patterns": [
      "アラレ"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No03-seimo-1x1-product-front-right-01.webp?v=1778315599",
        "alt": "No03 清茂 23型 南部型 アラレ 1.9L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No03-seimo-1x1-product-front-left-01.webp?v=1778315601",
        "alt": "No03 清茂 23型 南部型 アラレ 1.9L 正面・左向き"
      }
    }
  },
  "4": {
    "no": 4,
    "title": "★紅蓮堂（南部鉄器協同組合）鉄瓶 布団形みのり（環文様）1.5L 伝統工芸士 葛巻 元 作 【0035326】",
    "short_title": "紅蓮堂 鉄瓶 布団形みのり（環文様）1.5L",
    "handle": "0035326",
    "public_url": "https://iwatekensan-shop.com/products/0035326",
    "price": 48400,
    "price_display": "¥48,400",
    "maker_code": "guren",
    "maker_display_name": "紅蓮堂",
    "artisan_name": "葛巻 元",
    "capacity": "1.5L",
    "capacity_l": 1.5,
    "shape_pattern": "布団形みのり_環文様",
    "patterns": [
      "環文様"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No04-guren-1x1-product-front-right-01.webp?v=1778315608",
        "alt": "No04 紅蓮堂 布団形みのり 環文様 1.5L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No04-guren-1x1-product-front-left-01.webp?v=1778315607",
        "alt": "No04 紅蓮堂 布団形みのり 環文様 1.5L 正面・左向き"
      }
    }
  },
  "5": {
    "no": 5,
    "title": "★薫山工房（南部鉄器協同組合）鉄瓶 新布団型 肌 1.0L 伝統工芸士 佐々木 和夫 作 【0035327】",
    "short_title": "薫山工房 鉄瓶 新布団型 肌 1.0L",
    "handle": "0035327",
    "public_url": "https://iwatekensan-shop.com/products/0035327",
    "price": 44000,
    "price_display": "¥44,000",
    "maker_code": "kunzan",
    "maker_display_name": "薫山工房",
    "artisan_name": "佐々木 和夫",
    "capacity": "1.0L",
    "capacity_l": 1,
    "shape_pattern": "新布団型_肌",
    "patterns": [],
    "region": "morioka",
    "method": "焼型",
    "material": "",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No05-kunzan-1x1-product-front-right-01.webp?v=1778315613",
        "alt": "No05 薫山工房 新布団型 肌 1.0L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No05-kunzan-1x1-product-front-left-01.webp?v=1778315613",
        "alt": "No05 薫山工房 新布団型 肌 1.0L 正面・左向き"
      }
    }
  },
  "6": {
    "no": 6,
    "title": "★薫山工房（南部鉄器協同組合）鉄瓶 南部型 桜 2.0L 伝統工芸士 佐々木 和夫 作 【0035328】",
    "short_title": "薫山工房 鉄瓶 南部型 桜 2.0L",
    "handle": "0035328",
    "public_url": "https://iwatekensan-shop.com/products/0035328",
    "price": 121000,
    "price_display": "¥121,000",
    "maker_code": "kunzan",
    "maker_display_name": "薫山工房",
    "artisan_name": "佐々木 和夫",
    "capacity": "2.0L",
    "capacity_l": 2,
    "shape_pattern": "南部型_桜",
    "patterns": [
      "桜"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No06-kunzan-1x1-product-front-right-01.webp?v=1778315619",
        "alt": "No06 薫山工房 南部型 桜 2.0L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No06-kunzan-1x1-product-front-left-01.webp?v=1778315620",
        "alt": "No06 薫山工房 南部型 桜 2.0L 正面・左向き"
      }
    }
  },
  "7": {
    "no": 7,
    "title": "★岩鋳（南部鉄器協同組合）鉄瓶 23型南部肌 松つまみ 1.9L 伝統工芸士 清茂 作 【0035329】",
    "short_title": "岩鋳 鉄瓶 23型南部肌 松つまみ 1.9L",
    "handle": "0035329",
    "public_url": "https://iwatekensan-shop.com/products/0035329",
    "price": 78100,
    "price_display": "¥78,100",
    "maker_code": "seimo",
    "maker_display_name": "岩鋳",
    "artisan_name": "清茂",
    "capacity": "1.9L",
    "capacity_l": 1.9,
    "shape_pattern": "23型 南部型肌_松つまみ",
    "patterns": [
      "松つまみ"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No07-seimo-1x1-product-front-right-01.webp?v=1778315628",
        "alt": "No07 清茂 23型 南部型肌 松つまみ 1.9L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No07-seimo-1x1-product-front-left-01.webp?v=1778315630",
        "alt": "No07 清茂 23型 南部型肌 松つまみ 1.9L 正面・左向き"
      }
    }
  },
  "8": {
    "no": 8,
    "title": "★虎山工房（南部鉄器協同組合）砂鉄鉄瓶 南部形菊 2.7L 伝統工芸士 前田 知行 作 【0035330】",
    "short_title": "虎山工房 砂鉄鉄瓶 南部形菊 2.7L",
    "handle": "0035330",
    "public_url": "https://iwatekensan-shop.com/products/0035330",
    "price": 605000,
    "price_display": "¥605,000",
    "maker_code": "kozan",
    "maker_display_name": "虎山工房",
    "artisan_name": "前田 知行",
    "capacity": "2.7L",
    "capacity_l": 2.7,
    "shape_pattern": "南部形_菊",
    "patterns": [
      "菊"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No08-kozan-1x1-product-front-right-01.webp?v=1778315637",
        "alt": "No08 虎山 南部形 菊 2.7L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No08-kozan-1x1-product-front-left-01.webp?v=1778315637",
        "alt": "No08 虎山 南部形 菊 2.7L 正面・左向き"
      }
    }
  },
  "9": {
    "no": 9,
    "title": "★薫山工房（南部鉄器協同組合）鉄瓶 布団型 亀甲 2.2L 伝統工芸士 佐々木 和夫 作 【0035331】",
    "short_title": "薫山工房 鉄瓶 布団型 亀甲 2.2L",
    "handle": "0035331",
    "public_url": "https://iwatekensan-shop.com/products/0035331",
    "price": 99000,
    "price_display": "¥99,000",
    "maker_code": "kunzan",
    "maker_display_name": "薫山工房",
    "artisan_name": "佐々木 和夫",
    "capacity": "2.2L",
    "capacity_l": 2.2,
    "shape_pattern": "布団型_亀甲",
    "patterns": [
      "亀甲"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No09-kunzan-1x1-product-front-right-01.webp?v=1778315649",
        "alt": "No09 薫山工房 布団型 亀甲 2.2L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No09-kunzan-1x1-product-front-left-01.webp?v=1778315650",
        "alt": "No09 薫山工房 布団型 亀甲 2.2L 正面・左向き"
      }
    }
  },
  "10": {
    "no": 10,
    "title": "★薫山工房（南部鉄器協同組合）砂鉄鉄瓶 棗型 桜 1.6L 伝統工芸士 佐々木 和夫 作 【0035332】",
    "short_title": "薫山工房 砂鉄鉄瓶 棗型 桜 1.6L",
    "handle": "0035332",
    "public_url": "https://iwatekensan-shop.com/products/0035332",
    "price": 143000,
    "price_display": "¥143,000",
    "maker_code": "kunzan",
    "maker_display_name": "薫山工房",
    "artisan_name": "佐々木 和夫",
    "capacity": "1.6L",
    "capacity_l": 1.6,
    "shape_pattern": "棗型_桜",
    "patterns": [
      "桜"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No10-kunzan-1x1-product-front-right-01.webp?v=1778315483",
        "alt": "No10 薫山工房 棗型 桜 1.6L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No10-kunzan-1x1-product-front-left-01.webp?v=1778315483",
        "alt": "No10 薫山工房 棗型 桜 1.6L 正面・左向き"
      }
    }
  },
  "11": {
    "no": 11,
    "title": "★田山鐵瓶工房（南部鉄器協同組合）南部砂鉄 石割桜紋布団型鉄瓶（中）1.5L 桐箱入 伝統工芸士 田山 和康 作 【0035333】",
    "short_title": "田山鐵瓶工房 南部砂鉄 石割桜紋布団型鉄瓶（中）1.5L 桐箱入",
    "handle": "0035333",
    "public_url": "https://iwatekensan-shop.com/products/0035333",
    "price": 796400,
    "price_display": "¥796,400",
    "maker_code": "tayama",
    "maker_display_name": "田山鐵瓶工房",
    "artisan_name": "田山 和康",
    "capacity": "1.5L",
    "capacity_l": 1.5,
    "shape_pattern": "布団型(中)_石割桜紋",
    "patterns": [
      "桜",
      "石割桜"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": true,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No11-tayama-1x1-product-front-right-01.webp?v=1778315490",
        "alt": "No11 田山鐵瓶工房 布団型(中) 石割桜紋 1.5L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No11-tayama-1x1-product-front-left-01.webp?v=1778315492",
        "alt": "No11 田山鐵瓶工房 布団型(中) 石割桜紋 1.5L 正面・左向き"
      }
    }
  },
  "12": {
    "no": 12,
    "title": "★田山鐵瓶工房（南部鉄器協同組合）雪花紋布団型鉄瓶（大）1.8L 桐箱入 伝統工芸士 田山 和康 作 【0035334】",
    "short_title": "田山鐵瓶工房 雪花紋布団型鉄瓶（大）1.8L 桐箱入",
    "handle": "0035334",
    "public_url": "https://iwatekensan-shop.com/products/0035334",
    "price": 261800,
    "price_display": "¥261,800",
    "maker_code": "tayama",
    "maker_display_name": "田山鐵瓶工房",
    "artisan_name": "田山 和康",
    "capacity": "1.8L",
    "capacity_l": 1.8,
    "shape_pattern": "布団形(大)_雪花紋",
    "patterns": [
      "雪花"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "",
    "is_kiribako": true,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No12-tayama-1x1-product-front-right-01.webp?v=1778315499",
        "alt": "No12 田山鐵瓶工房 布団形(大) 雪花紋 1.8L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No12-tayama-1x1-product-front-left-01.webp?v=1778315499",
        "alt": "No12 田山鐵瓶工房 布団形(大) 雪花紋 1.8L 正面・左向き"
      }
    }
  },
  "13": {
    "no": 13,
    "title": "★田山鐵瓶工房（南部鉄器協同組合）松葉紋布団型鉄瓶（小）0.7L 桐箱入 伝統工芸士 田山 和康 作 【0035335】",
    "short_title": "田山鐵瓶工房 松葉紋布団型鉄瓶（小）0.7L 桐箱入",
    "handle": "0035335",
    "public_url": "https://iwatekensan-shop.com/products/0035335",
    "price": 178200,
    "price_display": "¥178,200",
    "maker_code": "tayama",
    "maker_display_name": "田山鐵瓶工房",
    "artisan_name": "田山 和康",
    "capacity": "0.7L",
    "capacity_l": 0.7,
    "shape_pattern": "布団形(小)_松葉紋",
    "patterns": [
      "松葉"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "",
    "is_kiribako": true,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No13-tayama-1x1-product-front-right-01.webp?v=1778315507",
        "alt": "No13 田山鐵瓶工房 布団形(小) 松葉紋 0.7L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No13-tayama-1x1-product-front-left-01.webp?v=1778315507",
        "alt": "No13 田山鐵瓶工房 布団形(小) 松葉紋 0.7L 正面・左向き"
      }
    }
  },
  "15": {
    "no": 15,
    "title": "★田山鐵瓶工房（南部鉄器協同組合）南部砂鉄 松葉紋布団型鉄瓶（小）0.65L 桐箱入 伝統工芸士 田山 和康 作 【0035336】",
    "short_title": "田山鐵瓶工房 南部砂鉄 松葉紋布団型鉄瓶（小）0.65L 桐箱入",
    "handle": "0035336",
    "public_url": "https://iwatekensan-shop.com/products/0035336",
    "price": 519200,
    "price_display": "¥519,200",
    "maker_code": "tayama",
    "maker_display_name": "田山鐵瓶工房",
    "artisan_name": "田山 和康",
    "capacity": "0.65L",
    "capacity_l": 0.65,
    "shape_pattern": "布団形(小)桐箱入_松葉紋(南部砂鉄)",
    "patterns": [
      "松葉"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": true,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No15-tayama-1x1-product-front-right-01.webp?v=1778315516",
        "alt": "No15 田山鐵瓶工房 布団形(小)桐箱入 松葉紋(南部砂鉄) 0.65L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No15-tayama-1x1-product-front-left-01.webp?v=1778315516",
        "alt": "No15 田山鐵瓶工房 布団形(小)桐箱入 松葉紋(南部砂鉄) 0.65L 正面・左向き"
      }
    }
  },
  "16": {
    "no": 16,
    "title": "★田山鐵瓶工房（南部鉄器協同組合）南部砂鉄 桜紋玉型鉄瓶 0.7L 桐箱入 伝統工芸士 田山 和康 作 【0035337】",
    "short_title": "田山鐵瓶工房 南部砂鉄 桜紋玉型鉄瓶 0.7L 桐箱入",
    "handle": "0035337",
    "public_url": "https://iwatekensan-shop.com/products/0035337",
    "price": 508200,
    "price_display": "¥508,200",
    "maker_code": "tayama",
    "maker_display_name": "田山鐵瓶工房",
    "artisan_name": "田山 和康",
    "capacity": "0.7L",
    "capacity_l": 0.7,
    "shape_pattern": "玉形_桜紋(南部砂鉄)",
    "patterns": [
      "桜"
    ],
    "region": "morioka",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": true,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No16-tayama-1x1-product-front-right-01.webp?v=1778315527",
        "alt": "No16 田山鐵瓶工房 玉形 桜紋(南部砂鉄) 0.7L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No16-tayama-1x1-product-front-left-01.webp?v=1778315527",
        "alt": "No16 田山鐵瓶工房 玉形 桜紋(南部砂鉄) 0.7L 正面・左向き"
      }
    }
  },
  "17": {
    "no": 17,
    "title": "★及鉄鋳造所宝鉄堂（水沢鋳物工業協同組合）砂鉄鉄瓶 宝珠形桜模様 1.4L 伝統工芸士 及川 栄喜 作 【0035338】",
    "short_title": "及鉄鋳造所宝鉄堂 砂鉄鉄瓶 宝珠形桜模様 1.4L",
    "handle": "0035338",
    "public_url": "https://iwatekensan-shop.com/products/0035338",
    "price": 363000,
    "price_display": "¥363,000",
    "maker_code": "eiki",
    "maker_display_name": "及鉄鋳造所宝鉄堂",
    "artisan_name": "及川 栄喜",
    "capacity": "1.4L",
    "capacity_l": 1.4,
    "shape_pattern": "宝珠形_桜模様",
    "patterns": [
      "桜",
      "宝珠"
    ],
    "region": "mizusawa",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No17-eiki-1x1-product-front-right-01.webp?v=1778315534",
        "alt": "No17 及川栄喜 宝珠形 桜模様 1.4L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No17-eiki-1x1-product-front-left-01.webp?v=1778315534",
        "alt": "No17 及川栄喜 宝珠形 桜模様 1.4L 正面・左向き"
      }
    }
  },
  "18": {
    "no": 18,
    "title": "★南部成龍堂（水沢鋳物工業協同組合）砂鉄鉄瓶 平南部桜 1.4L 伝統工芸士 及川 光正 作 【0035339】",
    "short_title": "南部成龍堂 砂鉄鉄瓶 平南部桜 1.4L",
    "handle": "0035339",
    "public_url": "https://iwatekensan-shop.com/products/0035339",
    "price": 242000,
    "price_display": "¥242,000",
    "maker_code": "mitsumasa",
    "maker_display_name": "南部成龍堂",
    "artisan_name": "及川 光正",
    "capacity": "1.4L",
    "capacity_l": 1.4,
    "shape_pattern": "平南部_桜",
    "patterns": [
      "桜"
    ],
    "region": "mizusawa",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No18-mitsumasa-1x1-product-front-right-01.webp?v=1778315539",
        "alt": "No18 光正 平南部 桜 1.4L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No18-mitsumasa-1x1-product-front-left-01.webp?v=1778315541",
        "alt": "No18 光正 平南部 桜 1.4L 正面・左向き"
      }
    }
  },
  "19": {
    "no": 19,
    "title": "★工房和秋（水沢鋳物工業協同組合）砂鉄鉄瓶 立口唐菊 1.4L 伝統工芸士 金野 和司 作 【0035340】",
    "short_title": "工房和秋 砂鉄鉄瓶 立口唐菊 1.4L",
    "handle": "0035340",
    "public_url": "https://iwatekensan-shop.com/products/0035340",
    "price": 181500,
    "price_display": "¥181,500",
    "maker_code": "kazushi",
    "maker_display_name": "工房和秋",
    "artisan_name": "金野 和司",
    "capacity": "1.4L",
    "capacity_l": 1.4,
    "shape_pattern": "立口_唐菊",
    "patterns": [
      "菊",
      "唐菊"
    ],
    "region": "mizusawa",
    "method": "",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No19-kazushi-1x1-product-front-right-01.webp?v=1778315548",
        "alt": "No19 金野 立口 唐菊 1.4L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No19-kazushi-1x1-product-front-left-01.webp?v=1778315548",
        "alt": "No19 金野 立口 唐菊 1.4L 正面・左向き"
      }
    }
  },
  "20": {
    "no": 20,
    "title": "★工房和秋（水沢鋳物工業協同組合）砂鉄鉄瓶 立口桜 1.4L 伝統工芸士 金野 和司 作 【0035341】",
    "short_title": "工房和秋 砂鉄鉄瓶 立口桜 1.4L",
    "handle": "0035341",
    "public_url": "https://iwatekensan-shop.com/products/0035341",
    "price": 181500,
    "price_display": "¥181,500",
    "maker_code": "kazushi",
    "maker_display_name": "工房和秋",
    "artisan_name": "金野 和司",
    "capacity": "1.4L",
    "capacity_l": 1.4,
    "shape_pattern": "立口_桜",
    "patterns": [
      "桜"
    ],
    "region": "mizusawa",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No20-kazushi-1x1-product-front-right-01.webp?v=1778315557",
        "alt": "No20 金野 立口 桜 1.4L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No20-kazushi-1x1-product-front-left-01.webp?v=1778315556",
        "alt": "No20 金野 立口 桜 1.4L 正面・左向き"
      }
    }
  },
  "21": {
    "no": 21,
    "title": "★奈の花（水沢鋳物工業協同組合）鉄瓶 南部型葡萄 茶 1.4L 伝統工芸士 佐々木 奈美 作 【0035342】",
    "short_title": "奈の花 鉄瓶 南部型葡萄 茶 1.4L",
    "handle": "0035342",
    "public_url": "https://iwatekensan-shop.com/products/0035342",
    "price": 145200,
    "price_display": "¥145,200",
    "maker_code": "nami",
    "maker_display_name": "奈の花",
    "artisan_name": "佐々木 奈美",
    "capacity": "1.4L",
    "capacity_l": 1.4,
    "shape_pattern": "南部形_葡萄_茶",
    "patterns": [
      "葡萄"
    ],
    "region": "mizusawa",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No21-nami-1x1-product-front-right-01.webp?v=1778315570",
        "alt": "No21 佐々木奈美 南部形 葡萄 茶 1.4L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No21-nami-1x1-product-front-left-01.webp?v=1778315570",
        "alt": "No21 佐々木奈美 南部形 葡萄 茶 1.4L 正面・左向き"
      }
    }
  },
  "22": {
    "no": 22,
    "title": "★南部成龍堂（水沢鋳物工業協同組合）砂鉄鉄瓶 花鳥 1.8L 伝統工芸士 及川 光正 作 【0035343】",
    "short_title": "南部成龍堂 砂鉄鉄瓶 花鳥 1.8L",
    "handle": "0035343",
    "public_url": "https://iwatekensan-shop.com/products/0035343",
    "price": 242000,
    "price_display": "¥242,000",
    "maker_code": "mitsumasa",
    "maker_display_name": "南部成龍堂",
    "artisan_name": "及川 光正",
    "capacity": "1.8L",
    "capacity_l": 1.8,
    "shape_pattern": "花鳥",
    "patterns": [
      "花鳥"
    ],
    "region": "mizusawa",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No22-mitsumasa-1x1-product-front-right-01.webp?v=1778315577",
        "alt": "No22 及川光正 花鳥 1.8L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No22-mitsumasa-1x1-product-front-left-01.webp?v=1778315576",
        "alt": "No22 及川光正 花鳥 1.8L 正面・左向き"
      }
    }
  },
  "23": {
    "no": 23,
    "title": "★及鉄鋳造所宝鉄堂（水沢鋳物工業協同組合）砂鉄鉄瓶 南部型雲龍 1.8L 伝統工芸士 及川 栄喜 作 【0035344】",
    "short_title": "及鉄鋳造所宝鉄堂 砂鉄鉄瓶 南部型雲龍 1.8L",
    "handle": "0035344",
    "public_url": "https://iwatekensan-shop.com/products/0035344",
    "price": 484000,
    "price_display": "¥484,000",
    "maker_code": "eiki",
    "maker_display_name": "及鉄鋳造所宝鉄堂",
    "artisan_name": "及川 栄喜",
    "capacity": "1.8L",
    "capacity_l": 1.8,
    "shape_pattern": "南部形_雲龍",
    "patterns": [
      "雲龍"
    ],
    "region": "mizusawa",
    "method": "焼型",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No23-eiki-1x1-product-front-right-01.webp?v=1778315584",
        "alt": "No23 及川栄喜 南部形 雲龍 1.8L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No23-eiki-1x1-product-front-left-01.webp?v=1778315585",
        "alt": "No23 及川栄喜 南部形 雲龍 1.8L 正面・左向き"
      }
    }
  },
  "24": {
    "no": 24,
    "title": "★工房和秋（水沢鋳物工業協同組合）砂鉄鉄瓶 立口雲龍 1.4L 伝統工芸士 金野 和司 作 【0035345】",
    "short_title": "工房和秋 砂鉄鉄瓶 立口雲龍 1.4L",
    "handle": "0035345",
    "public_url": "https://iwatekensan-shop.com/products/0035345",
    "price": 181500,
    "price_display": "¥181,500",
    "maker_code": "kazushi",
    "maker_display_name": "工房和秋",
    "artisan_name": "金野 和司",
    "capacity": "1.4L",
    "capacity_l": 1.4,
    "shape_pattern": "立口_雲龍",
    "patterns": [
      "雲龍"
    ],
    "region": "mizusawa",
    "method": "",
    "material": "砂鉄",
    "is_kiribako": false,
    "is_traditional_craftsman": true,
    "photos": {
      "primary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No24-kazushi-1x1-product-front-right-01.webp?v=1778315592",
        "alt": "No24 金野和司 立口 雲龍 1.4L 正面・右向き"
      },
      "secondary_1x1": {
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No24-kazushi-1x1-product-front-left-01.webp?v=1778315592",
        "alt": "No24 金野和司 立口 雲龍 1.4L 正面・左向き"
      }
    }
  }
};

const MAKERS_DATA = {
  "tayama": {
    "code": "tayama",
    "display_name": "田山鐵瓶工房",
    "artisan_name": "田山 和康",
    "region": "morioka",
    "product_nos": [
      11,
      12,
      13,
      15,
      16
    ],
    "product_count": 5,
    "is_featured": true,
    "primary_no": 11,
    "primary_photos": [
      {
        "view": "front-right",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No11-tayama-1x1-product-front-right-01.webp?v=1778315490",
        "alt": "No11 田山鐵瓶工房 布団型(中) 石割桜紋 1.5L 正面・右向き"
      },
      {
        "view": "front-left",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No11-tayama-1x1-product-front-left-01.webp?v=1778315492",
        "alt": "No11 田山鐵瓶工房 布団型(中) 石割桜紋 1.5L 正面・左向き"
      }
    ]
  },
  "kunzan": {
    "code": "kunzan",
    "display_name": "薫山工房",
    "artisan_name": "佐々木 和夫",
    "region": "morioka",
    "product_nos": [
      2,
      5,
      6,
      9,
      10
    ],
    "product_count": 5,
    "is_featured": true,
    "primary_no": 2,
    "primary_photos": [
      {
        "view": "front-right",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No02-kunzan-1x1-product-front-right-01.webp?v=1778315427",
        "alt": "No02 薫山工房 布団型 亀甲 1.6L 正面・右向き"
      },
      {
        "view": "front-left",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No02-kunzan-1x1-product-front-left-01.webp?v=1778315428",
        "alt": "No02 薫山工房 布団型 亀甲 1.6L 正面・左向き"
      }
    ]
  },
  "nami": {
    "code": "nami",
    "display_name": "奈の花",
    "artisan_name": "佐々木 奈美",
    "region": "mizusawa",
    "product_nos": [
      21
    ],
    "product_count": 1,
    "is_featured": true,
    "primary_no": 21,
    "primary_photos": [
      {
        "view": "front-right",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No21-nami-1x1-product-front-right-01.webp?v=1778315570",
        "alt": "No21 佐々木奈美 南部形 葡萄 茶 1.4L 正面・右向き"
      },
      {
        "view": "front-left",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No21-nami-1x1-product-front-left-01.webp?v=1778315570",
        "alt": "No21 佐々木奈美 南部形 葡萄 茶 1.4L 正面・左向き"
      }
    ]
  },
  "guren": {
    "code": "guren",
    "display_name": "紅蓮堂",
    "artisan_name": "葛巻 元",
    "region": "morioka",
    "product_nos": [
      4
    ],
    "product_count": 1,
    "is_featured": false,
    "primary_no": 4,
    "primary_photos": [
      {
        "view": "front-right",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No04-guren-1x1-product-front-right-01.webp?v=1778315608",
        "alt": "No04 紅蓮堂 布団形みのり 環文様 1.5L 正面・右向き"
      },
      {
        "view": "front-left",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No04-guren-1x1-product-front-left-01.webp?v=1778315607",
        "alt": "No04 紅蓮堂 布団形みのり 環文様 1.5L 正面・左向き"
      }
    ]
  },
  "kozan": {
    "code": "kozan",
    "display_name": "虎山工房",
    "artisan_name": "前田 知行",
    "region": "morioka",
    "product_nos": [
      8
    ],
    "product_count": 1,
    "is_featured": false,
    "primary_no": 8,
    "primary_photos": [
      {
        "view": "front-right",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No08-kozan-1x1-product-front-right-01.webp?v=1778315637",
        "alt": "No08 虎山 南部形 菊 2.7L 正面・右向き"
      },
      {
        "view": "front-left",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No08-kozan-1x1-product-front-left-01.webp?v=1778315637",
        "alt": "No08 虎山 南部形 菊 2.7L 正面・左向き"
      }
    ]
  },
  "seimo": {
    "code": "seimo",
    "display_name": "岩鋳",
    "artisan_name": "清茂",
    "region": "morioka",
    "product_nos": [
      3,
      7
    ],
    "product_count": 2,
    "is_featured": false,
    "primary_no": 3,
    "primary_photos": [
      {
        "view": "front-right",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No03-seimo-1x1-product-front-right-01.webp?v=1778315599",
        "alt": "No03 清茂 23型 南部型 アラレ 1.9L 正面・右向き"
      },
      {
        "view": "front-left",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No03-seimo-1x1-product-front-left-01.webp?v=1778315601",
        "alt": "No03 清茂 23型 南部型 アラレ 1.9L 正面・左向き"
      }
    ]
  },
  "eiki": {
    "code": "eiki",
    "display_name": "及鉄鋳造所宝鉄堂",
    "artisan_name": "及川 栄喜",
    "region": "mizusawa",
    "product_nos": [
      17,
      23
    ],
    "product_count": 2,
    "is_featured": false,
    "primary_no": 17,
    "primary_photos": [
      {
        "view": "front-right",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No17-eiki-1x1-product-front-right-01.webp?v=1778315534",
        "alt": "No17 及川栄喜 宝珠形 桜模様 1.4L 正面・右向き"
      },
      {
        "view": "front-left",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No17-eiki-1x1-product-front-left-01.webp?v=1778315534",
        "alt": "No17 及川栄喜 宝珠形 桜模様 1.4L 正面・左向き"
      }
    ]
  },
  "mitsumasa": {
    "code": "mitsumasa",
    "display_name": "南部成龍堂",
    "artisan_name": "及川 光正",
    "region": "mizusawa",
    "product_nos": [
      18,
      22
    ],
    "product_count": 2,
    "is_featured": false,
    "primary_no": 18,
    "primary_photos": [
      {
        "view": "front-right",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No18-mitsumasa-1x1-product-front-right-01.webp?v=1778315539",
        "alt": "No18 光正 平南部 桜 1.4L 正面・右向き"
      },
      {
        "view": "front-left",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No18-mitsumasa-1x1-product-front-left-01.webp?v=1778315541",
        "alt": "No18 光正 平南部 桜 1.4L 正面・左向き"
      }
    ]
  },
  "kazushi": {
    "code": "kazushi",
    "display_name": "工房和秋",
    "artisan_name": "金野 和司",
    "region": "mizusawa",
    "product_nos": [
      19,
      20,
      24
    ],
    "product_count": 3,
    "is_featured": false,
    "primary_no": 19,
    "primary_photos": [
      {
        "view": "front-right",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No19-kazushi-1x1-product-front-right-01.webp?v=1778315548",
        "alt": "No19 金野 立口 唐菊 1.4L 正面・右向き"
      },
      {
        "view": "front-left",
        "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No19-kazushi-1x1-product-front-left-01.webp?v=1778315548",
        "alt": "No19 金野 立口 唐菊 1.4L 正面・左向き"
      }
    ]
  }
};

const PATTERNS_DATA = {
  "桜": {
    "name": "桜",
    "representative_no": 6,
    "product_nos": [
      6,
      10,
      11,
      16,
      17,
      18,
      20
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No06-kunzan-3x2-product-texture-01.webp?v=1778315626",
      "alt": "No06 薫山工房 南部型 桜 2.0L 色・素材感"
    }
  },
  "亀甲": {
    "name": "亀甲",
    "representative_no": 2,
    "product_nos": [
      2,
      9
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No02-kunzan-3x2-product-texture-01.webp?v=1778315432",
      "alt": "No02 薫山工房 布団型 亀甲 1.6L 色・素材感"
    }
  },
  "アラレ": {
    "name": "アラレ",
    "representative_no": 3,
    "product_nos": [
      3
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No03-seimo-3x2-product-texture-01.webp?v=1778315604",
      "alt": "No03 清茂 23型 南部型 アラレ 1.9L 色・素材感"
    }
  },
  "雲龍": {
    "name": "雲龍",
    "representative_no": 23,
    "product_nos": [
      23,
      24
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No23-eiki-3x2-product-texture-01.webp?v=1778315589",
      "alt": "No23 及川栄喜 南部形 雲龍 1.8L 色・素材感"
    }
  },
  "葡萄": {
    "name": "葡萄",
    "representative_no": 21,
    "product_nos": [
      21
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No21-nami-3x2-product-texture-01.webp?v=1778315575",
      "alt": "No21 佐々木奈美 南部形 葡萄 茶 1.4L 色・素材感"
    }
  },
  "雪花": {
    "name": "雪花",
    "representative_no": 12,
    "product_nos": [
      12
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No12-tayama-3x2-product-texture-01.webp?v=1778315504",
      "alt": "No12 田山鐵瓶工房 布団形(大) 雪花紋 1.8L 色・素材感"
    }
  },
  "松葉": {
    "name": "松葉",
    "representative_no": 13,
    "product_nos": [
      13,
      15
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No13-tayama-3x2-product-texture-01.webp?v=1778315512",
      "alt": "No13 田山鐵瓶工房 布団形(小) 松葉紋 0.7L 色・素材感"
    }
  },
  "菊": {
    "name": "菊",
    "representative_no": 8,
    "product_nos": [
      8,
      19
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No08-kozan-3x2-product-texture-01.webp?v=1778315642",
      "alt": "No08 虎山 南部形 菊 2.7L 色・素材感"
    }
  },
  "唐菊": {
    "name": "唐菊",
    "representative_no": 19,
    "product_nos": [
      19
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No19-kazushi-3x2-product-texture-01.webp?v=1778315553",
      "alt": "No19 金野 立口 唐菊 1.4L 色・素材感"
    }
  },
  "石割桜": {
    "name": "石割桜",
    "representative_no": 11,
    "product_nos": [
      11
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No11-tayama-3x2-product-texture-01.webp?v=1778315497",
      "alt": "No11 田山鐵瓶工房 布団型(中) 石割桜紋 1.5L 色・素材感"
    }
  },
  "松つまみ": {
    "name": "松つまみ",
    "representative_no": 7,
    "product_nos": [
      7
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No07-seimo-3x2-product-texture-01.webp?v=1778315633",
      "alt": "No07 清茂 23型 南部型肌 松つまみ 1.9L 色・素材感"
    }
  },
  "宝珠": {
    "name": "宝珠",
    "representative_no": 17,
    "product_nos": [
      17
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No17-eiki-3x2-product-texture-01.webp?v=1778315537",
      "alt": "No17 及川栄喜 宝珠形 桜模様 1.4L 色・素材感"
    }
  },
  "花鳥": {
    "name": "花鳥",
    "representative_no": 22,
    "product_nos": [
      22
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No22-mitsumasa-3x2-product-texture-01.webp?v=1778315582",
      "alt": "No22 及川光正 花鳥 1.8L 色・素材感"
    }
  },
  "環文様": {
    "name": "環文様",
    "representative_no": 4,
    "product_nos": [
      4
    ],
    "photo": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No04-guren-3x2-product-texture-01.webp?v=1778315613",
      "alt": "No04 紅蓮堂 布団形みのり 環文様 1.5L 色・素材感"
    }
  }
};

const GROUP_PHOTOS = [
  {
    "shopify_filename": "tetsubin-group-3x2-01.webp",
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-group-3x2-01.webp?v=1778315696",
    "alt": "南部鉄器 鉄瓶 集合写真 横01",
    "aspect": "3x2",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-3x2-02-01.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 横02-01",
    "aspect": "3x2",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-3x2-02-02.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 横02-02",
    "aspect": "3x2",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-3x2-03-01.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 横03-01",
    "aspect": "3x2",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-3x2-03-02.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 横03-02",
    "aspect": "3x2",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-3x2-04.webp",
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-group-3x2-04.webp?v=1778315698",
    "alt": "南部鉄器 鉄瓶 集合写真 横04",
    "aspect": "3x2",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-3x2-04-wide.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 横04（広めトリミング）",
    "aspect": "3x2",
    "is_wide_variant": true
  },
  {
    "shopify_filename": "tetsubin-group-2x3-01-01.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 縦01-01",
    "aspect": "2x3",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-2x3-01-02-wide.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 縦01-02（広めトリミング）",
    "aspect": "2x3",
    "is_wide_variant": true
  },
  {
    "shopify_filename": "tetsubin-group-2x3-01-03-wide.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 縦01-03（広めトリミング）",
    "aspect": "2x3",
    "is_wide_variant": true
  },
  {
    "shopify_filename": "tetsubin-group-2x3-01-04.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 縦01-04",
    "aspect": "2x3",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-2x3-01-05.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 縦01-05",
    "aspect": "2x3",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-2x3-01-06.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 縦01-06",
    "aspect": "2x3",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-2x3-01-07.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 縦01-07",
    "aspect": "2x3",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-2x3-02.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 縦02",
    "aspect": "2x3",
    "is_wide_variant": false
  },
  {
    "shopify_filename": "tetsubin-group-2x3-03.webp",
    "cdn_url": null,
    "alt": "南部鉄器 鉄瓶 集合写真 縦03",
    "aspect": "2x3",
    "is_wide_variant": false
  }
];

const FV_CANDIDATES = [
  {
    "no": 5,
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No05-kunzan-2x3-fv-01.webp?v=1778315613",
    "alt": "No05 薫山工房 新布団型 肌 1.0L FV 01",
    "aspect": "2x3",
    "maker_code": "kunzan"
  },
  {
    "no": 6,
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No06-kunzan-2x3-fv-01.webp?v=1778315620",
    "alt": "No06 薫山工房 南部型 桜 2.0L FV 01",
    "aspect": "2x3",
    "maker_code": "kunzan"
  },
  {
    "no": 7,
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No07-seimo-2x3-fv-01.webp?v=1778315626",
    "alt": "No07 清茂 23型 南部型肌 松つまみ 1.9L FV 01",
    "aspect": "2x3",
    "maker_code": "seimo"
  },
  {
    "no": 16,
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No16-tayama-2x3-fv-01.webp?v=1778315532",
    "alt": "No16 田山鐵瓶工房 玉形 桜紋(南部砂鉄) 0.7L FV 01",
    "aspect": "2x3",
    "maker_code": "tayama"
  },
  {
    "no": 19,
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No19-kazushi-2x3-fv-01.webp?v=1778315545",
    "alt": "No19 金野 立口 唐菊 1.4L FV 01",
    "aspect": "2x3",
    "maker_code": "kazushi"
  },
  {
    "no": 21,
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No21-nami-2x3-fv-01.webp?v=1778315574",
    "alt": "No21 佐々木奈美 南部形 葡萄 茶 1.4L FV 01",
    "aspect": "2x3",
    "maker_code": "nami"
  }
];

const SELECTED_FV_NO = 7;

const KIRIBAKO_NOS = [11,12,13,15,16];

/* Phase 3D: 新メーカー推奨順に合わせ、同メーカー内は番号順（桐箱入優先含む）
   tayama: 11,12,13,15,16 / kunzan: 2,5,6,9,10 / nami: 21
   kazushi: 19,20,24 / seimo: 3,7 / eiki: 17,23
   mitsumasa: 18,22 / guren: 4 / kozan: 8 */
const LINEUP_DEFAULT_ORDER = [11,12,13,15,16,2,5,6,9,10,21,19,20,24,3,7,17,23,18,22,4,8];

/* Phase 3D: メーカー表示順を「商品数の多さ＋受賞歴・知名度」の総合評価で並べ直す
   1.田山(5商品/現代の名工) 2.薫山(5商品/伝統工芸士) 3.奈の花(経済産業大臣賞/政府公式紹介)
   4.工房和秋(3商品/日展) 5.岩鋳(2商品/明治35年創業) 6.及鉄(2商品/水沢)
   7.南部成龍堂(2商品/水沢) 8.紅蓮堂(1商品) 9.虎山工房(1商品) */
const MAKER_FEATURED_ORDER = ["tayama","kunzan","nami"];

const MAKER_LIST_ORDER = ["kazushi","seimo","eiki","mitsumasa","guren","kozan"];

/* Phase 3D: 紋様の意匠順（古くから親しまれてきた意匠の歩みの順、嶋崎さん指示） */
const PATTERN_ORDER = ["亀甲","桜","石割桜","アラレ","松葉","雪花","雲龍","宝珠","葡萄","唐菊","菊","花鳥","松つまみ","環文様"];

const GIFT_SCENES = {
  "scene1_kanreki": [
    11,
    12,
    15
  ],
  "scene2_kekkon": [
    21,
    2,
    19
  ],
  "scene3_chichihaha": [
    7,
    5,
    6
  ],
  "scene4_kaigai": [
    16,
    21,
    17
  ]
};

const KIRIBAKO_PHOTOS = {
  "11": {
    "box": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No11-tayama-1x1-product-box-01.webp?v=1778315493",
      "alt": "No11 田山鐵瓶工房 布団型(中) 石割桜紋 1.5L 桐箱"
    },
    "product": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No11-tayama-1x1-product-front-right-01.webp?v=1778315490",
      "alt": "No11 田山鐵瓶工房 布団型(中) 石割桜紋 1.5L 正面・右向き"
    }
  },
  "12": {
    "box": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No12-tayama-1x1-product-box-01.webp?v=1778315500",
      "alt": "No12 田山鐵瓶工房 布団形(大) 雪花紋 1.8L 桐箱"
    },
    "product": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No12-tayama-1x1-product-front-right-01.webp?v=1778315499",
      "alt": "No12 田山鐵瓶工房 布団形(大) 雪花紋 1.8L 正面・右向き"
    }
  },
  "13": {
    "box": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No13-tayama-1x1-product-box-01.webp?v=1778315507",
      "alt": "No13 田山鐵瓶工房 布団形(小) 松葉紋 0.7L 桐箱"
    },
    "product": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No13-tayama-1x1-product-front-right-01.webp?v=1778315507",
      "alt": "No13 田山鐵瓶工房 布団形(小) 松葉紋 0.7L 正面・右向き"
    }
  },
  "15": {
    "box": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No15-tayama-1x1-product-box-01.webp?v=1778315514",
      "alt": "No15 田山鐵瓶工房 布団形(小)桐箱入 松葉紋(南部砂鉄) 0.65L 桐箱"
    },
    "product": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No15-tayama-1x1-product-front-right-01.webp?v=1778315516",
      "alt": "No15 田山鐵瓶工房 布団形(小)桐箱入 松葉紋(南部砂鉄) 0.65L 正面・右向き"
    }
  },
  "16": {
    "box": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No16-tayama-1x1-product-box-01.webp?v=1778315524",
      "alt": "No16 田山鐵瓶工房 玉形 桜紋(南部砂鉄) 0.7L 桐箱"
    },
    "product": {
      "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No16-tayama-1x1-product-front-right-01.webp?v=1778315527",
      "alt": "No16 田山鐵瓶工房 玉形 桜紋(南部砂鉄) 0.7L 正面・右向き"
    }
  }
};

const S8_LIFESTYLE_PHOTOS = [
  {
    "no": 11,
    "label": "田山鐵瓶工房・田山和康氏（現代の名工）",
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No11-tayama-2x3-lifestyle-01.webp?v=1778315489",
    "alt": "No11 田山鐵瓶工房 布団型(中) 石割桜紋 1.5L イメージ 01",
    "aspect": "2x3"
  },
  {
    "no": 21,
    "label": "奈の花・佐々木奈美氏（経済産業大臣賞受賞）",
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No21-nami-3x2-lifestyle-01.webp?v=1778315565",
    "alt": "No21 佐々木奈美 南部形 葡萄 茶 1.4L イメージ 01",
    "aspect": "3x2"
  },
  {
    "no": 9,
    "label": "薫山工房・佐々木和夫氏（伝統工芸士・薫山三代目）",
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No09-kunzan-3x2-lifestyle-01.webp?v=1778315645",
    "alt": "No09 薫山工房 布団型 亀甲 2.2L イメージ 01",
    "aspect": "3x2"
  }
];

const S3_PHOTOS = {
  "morioka": {
    "no": 11,
    "shopify_filename": "tetsubin-No11-tayama-2x3-lifestyle-01.webp",
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No11-tayama-2x3-lifestyle-01.webp?v=1778315489",
    "alt": "No11 田山鐵瓶工房 布団型(中) 石割桜紋 1.5L イメージ 01",
    "aspect": "2x3",
    "shot": "lifestyle",
    "view": null,
    "maker_code": "tayama"
  },
  "mizusawa": {
    "no": 21,
    "shopify_filename": "tetsubin-No21-nami-3x2-lifestyle-01.webp",
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-No21-nami-3x2-lifestyle-01.webp?v=1778315565",
    "alt": "No21 佐々木奈美 南部形 葡萄 茶 1.4L イメージ 01",
    "aspect": "3x2",
    "shot": "lifestyle",
    "view": null,
    "maker_code": "nami"
  },
  "group_overview": {
    "shopify_filename": "tetsubin-group-3x2-01.webp",
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-group-3x2-01.webp?v=1778315696",
    "alt": "南部鉄器 鉄瓶 集合写真 横01",
    "aspect": "3x2"
  }
};

const S2_BACKGROUND_PHOTOS = [
  {
    "shopify_filename": "tetsubin-group-3x2-01.webp",
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-group-3x2-01.webp?v=1778315696",
    "alt": "南部鉄器 鉄瓶 集合写真 横01",
    "aspect": "3x2"
  },
  {
    "shopify_filename": "tetsubin-group-3x2-04.webp",
    "cdn_url": "https://cdn.shopify.com/s/files/1/0658/2599/7043/files/tetsubin-group-3x2-04.webp?v=1778315698",
    "alt": "南部鉄器 鉄瓶 集合写真 横04",
    "aspect": "3x2"
  }
];

// ===== DATA SECTION END =====

// ===== INTERACTIVE LOGIC START =====
//
// 鉄瓶LP インタラクティブロジック（Phase 3B 手動メンテナンス領域）
// データ参照は上部の DATA SECTION (PRODUCTS_DATA / MAKERS_DATA / 等) を使用。
// HTML 側のフックは data-* 属性で結びつける。
//
// 主な機能：
//   - FV 写真の差し替え（SELECTED_FV_NO に応じて HTML の data-fv-image を上書き）
//   - 追従ナビ表示判定（スクロール量に応じた fade）
//   - 追従ナビ ドロワー開閉（SP のみ、外側クリック / Escape / リンク選択で閉じる）
//   - 追従ナビ アクティブセクション ハイライト（IntersectionObserver）
//   - 追従ナビ コンテキスト連動（S4 にいる時は 9メーカー一覧、S5 にいる時は 22商品リスト）
//   - フェードイン（軽量、prefers-reduced-motion 尊重）
//   - S5 商品ラインナップ レンダリング & フィルタソート & メーカー絞り込み

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function escHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function mqMobile() {
    return window.matchMedia('(max-width: 768px)');
  }

  // IH対応バッジを出す商品（2026-08-14 修正）
  // 根拠: 各商品ページ「熱源」欄。No12/13/15/16 のみ「ガス直火使用可・IH使用可」。
  // 同じ田山鐵瓶工房でも No11（石割桜 1.5L）は「IH使用不可」のため除外する。
  const IH_PRODUCT_NOS = [12, 13, 15, 16];

  // 状態管理
  const state = {
    currentSortBy: 'maker',
    currentMakerFilter: null,  // null = 全件表示、code = 該当メーカーのみ
    currentNavContext: 'default',  // 'default' / 'makers' / 'products'
    navContextLocked: false,       // ユーザーが「戻る」を押した時、自動切替を一時停止
  };

  // ------------------------------------------------------------------------
  // FV 写真の差し替え
  // ------------------------------------------------------------------------
  function applyFV() {
    const fvImg = document.querySelector('[data-fv-image]');
    if (!fvImg || typeof FV_CANDIDATES === 'undefined' || typeof SELECTED_FV_NO === 'undefined') return;
    const candidate = FV_CANDIDATES.find(c => c.no === SELECTED_FV_NO);
    if (!candidate) return;
    if (fvImg.getAttribute('src') !== candidate.cdn_url) {
      fvImg.src = candidate.cdn_url;
      fvImg.alt = candidate.alt;
    }
  }

  // ------------------------------------------------------------------------
  // 追従ナビ：スクロール量に応じた fade-in
  // ------------------------------------------------------------------------
  function initFollowNavVisibility() {
    const nav = document.querySelector('.follow-nav');
    if (!nav) return;
    const showAt = window.innerHeight * 0.6;
    let raf = null;
    function update() {
      if (window.scrollY > showAt) nav.classList.add('is-visible');
      else nav.classList.remove('is-visible');
      raf = null;
    }
    function onScroll() {
      if (raf == null) raf = window.requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  // ------------------------------------------------------------------------
  // 追従ナビ：SP ドロワー開閉
  // ------------------------------------------------------------------------
  function initFollowNavToggle() {
    const nav = document.querySelector('.follow-nav');
    if (!nav) return;
    const toggle = nav.querySelector('[data-follow-nav-toggle]');
    const panel = nav.querySelector('.follow-nav__panel');
    if (!toggle || !panel) return;

    function open() {
      nav.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      if (!nav.classList.contains('is-open')) return;
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      if (nav.classList.contains('is-open')) close();
      else open();
    });

    document.addEventListener('click', (e) => {
      if (!nav.classList.contains('is-open')) return;
      if (nav.contains(e.target)) return;
      close();
    });

    // panel 内のリンクを click したら閉じる（SP のみ）
    nav.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"], a[href^="https://"]');
      if (a && mqMobile().matches) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    mqMobile().addEventListener('change', () => close());
  }

  // ------------------------------------------------------------------------
  // Phase 3D: 追従ナビ「このメニューを閉じる」ボタン + 再表示ボタン
  //   PC は折り畳み（オフスクリーン）、SP はドロワーを閉じる挙動
  // ------------------------------------------------------------------------
  function initFollowNavCollapse() {
    const nav = document.querySelector('.follow-nav');
    const closeBtn = document.querySelector('[data-follow-nav-close]');
    const reopenBtn = document.querySelector('[data-follow-nav-reopen]');
    if (!nav || !closeBtn || !reopenBtn) return;

    function collapse() {
      if (mqMobile().matches) {
        // SP：ドロワーを閉じる（既存挙動を活用）
        nav.classList.remove('is-open');
        const toggle = nav.querySelector('[data-follow-nav-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
      // PC + SP 共通：完全に隠して再表示ボタンを出す
      nav.classList.add('is-collapsed');
      reopenBtn.hidden = false;
      // 少し遅延してフェードイン
      requestAnimationFrame(() => reopenBtn.classList.add('is-visible'));
    }
    function reopen() {
      nav.classList.remove('is-collapsed');
      reopenBtn.classList.remove('is-visible');
      // hidden は遷移完了後に
      setTimeout(() => { reopenBtn.hidden = true; }, 320);
    }
    closeBtn.addEventListener('click', collapse);
    reopenBtn.addEventListener('click', reopen);
  }

  // ------------------------------------------------------------------------
  // 追従ナビ：アクティブセクション + コンテキスト切替
  // ------------------------------------------------------------------------
  function initActiveSectionObserver() {
    const sections = document.querySelectorAll('main > section[id]');
    if (!sections.length) return;

    function setActive(id) {
      // default view の sections links
      document.querySelectorAll('.follow-nav__sections a[href^="#"]').forEach(a => {
        if (a.getAttribute('href') === '#' + id) a.classList.add('is-active');
        else a.classList.remove('is-active');
      });
      // コンテキスト連動（lock されていない場合のみ）
      if (!state.navContextLocked) {
        let context = 'default';
        if (id === 's4-makers') context = 'makers';
        else if (id === 's5-lineup') context = 'products';
        switchNavView(context);
      }
    }

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter(e => e.isIntersecting)
        .sort((a, b) => a.target.offsetTop - b.target.offsetTop);
      if (visible.length) {
        setActive(visible[0].target.id);
      }
    }, {
      rootMargin: '-30% 0px -55% 0px',
      threshold: 0
    });

    sections.forEach(s => observer.observe(s));
  }

  // 追従ナビ：view 切替（fade transition）
  function switchNavView(context) {
    if (context === state.currentNavContext) return;
    const nav = document.querySelector('.follow-nav');
    const views = document.querySelectorAll('.follow-nav__view');
    if (!nav || !views.length) return;

    nav.classList.add('is-changing');
    setTimeout(() => {
      views.forEach(v => {
        if (v.dataset.navView === context) v.removeAttribute('hidden');
        else v.setAttribute('hidden', '');
      });
      state.currentNavContext = context;
      nav.classList.remove('is-changing');
    }, 200);
  }

  // ------------------------------------------------------------------------
  // 追従ナビ：9メーカー一覧の動的生成
  // ------------------------------------------------------------------------
  function renderFollowNavMakers() {
    const list = document.querySelector('[data-nav-makers-list]');
    if (!list || typeof MAKERS_DATA === 'undefined') return;
    const order = [...MAKER_FEATURED_ORDER, ...MAKER_LIST_ORDER];
    list.innerHTML = order.map(code => {
      const m = MAKERS_DATA[code];
      if (!m) return '';
      const region = m.region === 'morioka' ? '盛岡' : '水沢';
      const featuredLabel = m.is_featured ? '特集' : region;
      return `
        <li>
          <a class="follow-nav__maker-link" href="#s5-lineup" data-jump-maker="${escHtml(code)}">
            <span class="follow-nav__maker-name">${escHtml(m.display_name)}</span>
            <span class="follow-nav__maker-artisan">${escHtml(m.artisan_name)} 作</span>
            <span class="follow-nav__maker-meta">${escHtml(featuredLabel)}　／　${m.product_count}作品</span>
          </a>
        </li>
      `;
    }).join('');
  }

  // ------------------------------------------------------------------------
  // 追従ナビ：22商品クイックジャンプの動的生成（メーカー別グループ）
  // ------------------------------------------------------------------------
  function renderFollowNavProducts() {
    const container = document.querySelector('[data-nav-products-list]');
    if (!container || typeof PRODUCTS_DATA === 'undefined') return;
    const order = [...MAKER_FEATURED_ORDER, ...MAKER_LIST_ORDER];
    container.innerHTML = order.map(code => {
      const m = MAKERS_DATA[code];
      if (!m) return '';
      const nos = m.product_nos;
      if (!nos || !nos.length) return '';
      return `
        <ul class="follow-nav__group">
          <li>
            <p class="follow-nav__group-heading">${escHtml(m.display_name)}</p>
            <ul>
              ${nos.map(no => {
                const p = PRODUCTS_DATA[no];
                if (!p) return '';
                const label = `No${String(no).padStart(2, '0')}　${p.shape_pattern.replace(/_/g, ' ')}　${p.capacity}`;
                return `<li><a href="#s5-lineup" data-product-jump="${no}" title="${escHtml(p.short_title)}">${escHtml(label)}</a></li>`;
              }).join('')}
            </ul>
          </li>
        </ul>
      `;
    }).join('');
  }

  // 追従ナビ「戻る」ボタン
  function initFollowNavBack() {
    document.querySelectorAll('[data-nav-back]').forEach(btn => {
      btn.addEventListener('click', () => {
        state.navContextLocked = true;
        switchNavView('default');
        // 一定時間後に lock 解除（次のスクロールで自動切替を再開）
        setTimeout(() => { state.navContextLocked = false; }, 800);
      });
    });
  }

  // ------------------------------------------------------------------------
  // Phase 3D: FV キャッチコピーのタイピングアニメーション
  //   - data-text 属性から原文を読み、1文字ずつ表示（100ms間隔）
  //   - prefers-reduced-motion: reduce 環境では全文を即時表示
  //   - 完了時に .fv__catch--typed--done クラスを付与（カーソル停止）
  // ------------------------------------------------------------------------
  function initTypingHeadline() {
    const target = document.querySelector('.fv__catch--typed');
    if (!target) return;
    const text = target.getAttribute('data-text') || '';
    if (!text) return;
    // reduced-motion 環境では即時表示
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      target.textContent = text;
      target.classList.add('fv__catch--typed--done');
      return;
    }
    target.textContent = '';
    let i = 0;
    const intervalMs = 100;
    const startDelay = 600;
    setTimeout(() => {
      const id = setInterval(() => {
        if (i >= text.length) {
          clearInterval(id);
          target.classList.add('fv__catch--typed--done');
          return;
        }
        target.textContent += text.charAt(i);
        i++;
      }, intervalMs);
    }, startDelay);
  }

  // ------------------------------------------------------------------------
  // Phase 3D: S8 voice-item のプレースホルダー写真に作家姓1文字を表示
  //   Phase 4 以降で実写真を追加する場合は <div data-voice-photo> を <img> に置換
  // ------------------------------------------------------------------------
  function initVoicePhotoPlaceholders() {
    const items = document.querySelectorAll('.voice-item');
    items.forEach(item => {
      const placeholder = item.querySelector('[data-voice-photo]');
      const nameEl = item.querySelector('.voice-item__name');
      if (!placeholder || !nameEl) return;
      const name = (nameEl.textContent || '').trim();
      if (!name) return;
      // 「田山 和康　氏」のような表記から最初の文字を取得
      const firstChar = name.charAt(0);
      placeholder.textContent = firstChar;
    });
  }

  // ------------------------------------------------------------------------
  // Phase 3D: スクロール連動 reveal-up（fade-in より広い汎用）
  // ------------------------------------------------------------------------
  function initRevealUp() {
    const targets = document.querySelectorAll('.reveal-up');
    if (!targets.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(el => el.classList.add('is-revealed'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -25% 0px', threshold: 0.05 });
    targets.forEach(el => observer.observe(el));
  }

  // ------------------------------------------------------------------------
  // Phase 3D: section-title-bg のパララックス（IntersectionObserver + transform）
  //   - prefers-reduced-motion: reduce 環境では無効化
  // ------------------------------------------------------------------------
  function initParallaxBg() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const bgs = document.querySelectorAll('.section-title-bg img');
    if (!bgs.length) return;
    let raf = null;
    function update() {
      const vh = window.innerHeight;
      bgs.forEach(img => {
        const rect = img.getBoundingClientRect();
        // 視差量：要素中心が viewport 中心からどれだけ離れているか
        const center = rect.top + rect.height / 2;
        const offset = (center - vh / 2) / vh;  // -1 〜 +1 程度
        const translate = Math.max(-30, Math.min(30, offset * -20));  // 最大 30px
        img.style.transform = `translateY(${translate}px)`;
      });
      raf = null;
    }
    function onScroll() {
      if (raf == null) raf = window.requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  // ------------------------------------------------------------------------
  // フェードイン（軽量、prefers-reduced-motion 尊重）
  // ------------------------------------------------------------------------
  function initFadeIn() {
    const targets = document.querySelectorAll('.fade-in');
    if (!targets.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(el => observer.observe(el));
  }

  // ------------------------------------------------------------------------
  // S5 商品ラインナップ：レンダリング + フィルタソート + メーカー絞り込み
  // ------------------------------------------------------------------------
  function lineupSortKey(no, sortBy) {
    const p = PRODUCTS_DATA[no];
    if (!p) return Infinity;
    switch (sortBy) {
      case 'price-asc':    return p.price;
      case 'price-desc':   return -p.price;
      case 'capacity-asc': return p.capacity_l != null ? p.capacity_l : Infinity;
      case 'capacity-desc':return p.capacity_l != null ? -p.capacity_l : -Infinity;
      case 'maker': {
        const order = [...MAKER_FEATURED_ORDER, ...MAKER_LIST_ORDER];
        return order.indexOf(p.maker_code);
      }
      case 'pattern': {
        const first = p.patterns && p.patterns[0];
        return first ? PATTERN_ORDER.indexOf(first) : Infinity;
      }
      default: return 0;
    }
  }

  function renderLineupCard(no) {
    const p = PRODUCTS_DATA[no];
    if (!p) return '';
    const primary = p.photos.primary_1x1;
    const secondary = p.photos.secondary_1x1;
    const altText = primary ? primary.alt : `No${String(no).padStart(2, '0')} ${p.short_title}`;
    const kiribako = p.is_kiribako ? '<span class="card-badge card-badge--kiribako">桐箱入</span>' : '';
    const ih = IH_PRODUCT_NOS.includes(Number(no)) ? '<span class="card-badge card-badge--ih">IH対応</span>' : '';
    const metaParts = [];
    if (p.capacity) metaParts.push(`<span>${escHtml(p.capacity)}</span>`);
    if (p.material) metaParts.push(`<span>${escHtml(p.material)}</span>`);
    if (p.patterns && p.patterns.length) metaParts.push(`<span>${escHtml(p.patterns.join('・'))}</span>`);
    return `
      <a class="lineup-card" href="${escHtml(p.public_url)}" data-product-no="${no}" data-product-handle="${escHtml(p.handle)}" data-maker="${escHtml(p.maker_code)}" target="_blank" rel="noopener">
        <div class="lineup-card__thumb">
          <img class="lineup-card__img lineup-card__img--primary" src="${escHtml(primary.cdn_url)}" alt="${escHtml(altText)}" loading="lazy" width="600" height="600">
          ${secondary ? `<img class="lineup-card__img lineup-card__img--secondary" src="${escHtml(secondary.cdn_url)}" alt="${escHtml(secondary.alt)}" loading="lazy" width="600" height="600">` : ''}
          ${kiribako}${ih}
        </div>
        <div class="lineup-card__body">
          <p class="lineup-card__maker">${escHtml(p.maker_display_name)}</p>
          <h3 class="lineup-card__title">${escHtml(p.short_title)}</h3>
          <p class="lineup-card__meta">${metaParts.join('')}</p>
          <p class="lineup-card__price">${escHtml(p.price_display)}</p>
        </div>
      </a>
    `;
  }

  function renderLineup() {
    const grid = document.querySelector('[data-lineup-grid]');
    if (!grid) return;
    let nos;
    if (state.currentMakerFilter) {
      // メーカー絞り込み中：該当メーカーの商品のみ、デフォルト順を維持
      const filterCode = state.currentMakerFilter;
      nos = LINEUP_DEFAULT_ORDER.filter(no => {
        const p = PRODUCTS_DATA[no];
        return p && p.maker_code === filterCode;
      });
    } else {
      // Phase 3D 修正: 'maker' でも同メーカーがまとまるようソートする
      // （以前は !== 'maker' でスキップしていたためデフォルトでメーカーが混在していた、嶋崎さん指摘）
      nos = LINEUP_DEFAULT_ORDER.slice();
      if (state.currentSortBy) {
        nos.sort((a, b) => lineupSortKey(a, state.currentSortBy) - lineupSortKey(b, state.currentSortBy));
      }
    }
    grid.innerHTML = nos.map(renderLineupCard).join('');
  }

  function updateActiveFilterTag() {
    const tag = document.querySelector('[data-lineup-active-filter]');
    const nameEl = document.querySelector('[data-lineup-active-filter-name]');
    if (!tag || !nameEl) return;
    if (state.currentMakerFilter) {
      const m = MAKERS_DATA[state.currentMakerFilter];
      if (m) {
        const count = (m.product_nos && m.product_nos.length) ? m.product_nos.length : '';
        nameEl.textContent = `${m.display_name}（${count}点）`;
        tag.classList.add('is-active');
        return;
      }
    }
    tag.classList.remove('is-active');
  }

  function clearMakerFilter() {
    state.currentMakerFilter = null;
    renderLineup();
    updateActiveFilterTag();
    // ソートボタンの aria-selected と is-active を同期
    document.querySelectorAll('[data-lineup-sort]').forEach(b => {
      const isCurrent = b.dataset.lineupSort === state.currentSortBy;
      b.classList.toggle('is-active', isCurrent);
      b.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
    });
  }

  function updatePatternCaption() {
    const cap = document.querySelector('[data-lineup-filter-caption]');
    if (!cap) return;
    cap.hidden = state.currentSortBy !== 'pattern';
  }

  function initLineupFilters() {
    const grid = document.querySelector('[data-lineup-grid]');
    const buttons = document.querySelectorAll('[data-lineup-sort]');
    if (!grid || !buttons.length) return;
    renderLineup();
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        // ソートボタンを押した瞬間にメーカー絞り込みは解除
        state.currentMakerFilter = null;
        state.currentSortBy = btn.dataset.lineupSort;
        buttons.forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        renderLineup();
        updateActiveFilterTag();
        updatePatternCaption();
      });
    });
    // クリアボタン
    const clearBtn = document.querySelector('[data-lineup-active-filter-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', clearMakerFilter);
    }
    updatePatternCaption();
  }

  // ------------------------------------------------------------------------
  // メーカーCTA → S5 メーカー絞り込み + スクロール
  //   data-jump-maker="<code>" がついた要素クリック時、該当メーカーで絞り込み表示
  // ------------------------------------------------------------------------
  function initMakerJump() {
    document.body.addEventListener('click', (e) => {
      const el = e.target.closest('[data-jump-maker]');
      if (!el) return;
      const code = el.dataset.jumpMaker;
      if (!code || !MAKERS_DATA[code]) return;
      // 既定の anchor jump は許可（href="#s5-lineup" でスクロール）
      // しかし JS で絞り込みを優先実行するため、デフォルト動作を残しつつ即座に状態更新
      state.currentMakerFilter = code;
      renderLineup();
      updateActiveFilterTag();
      // S5 セクションの上端へ scrollIntoView（PC では追従ナビが場所を取るので margin-top 補正）
      const target = document.getElementById('s5-lineup');
      if (target) {
        // 既定の href="#s5-lineup" のスムーススクロールを尊重しつつ、必要時の補完
        // ※ event.preventDefault() しない理由：ブラウザ標準 hash 更新で履歴に残る方が UX 良し
      }
    });
  }

  // ------------------------------------------------------------------------
  // 追従ナビ panel 内の商品リンククリック
  //   data-product-jump="<no>" → 該当 lineup-card にスクロール + 強調
  // ------------------------------------------------------------------------
  function initProductJump() {
    document.body.addEventListener('click', (e) => {
      const el = e.target.closest('[data-product-jump]');
      if (!el) return;
      e.preventDefault();
      const no = parseInt(el.dataset.productJump, 10);
      if (!no) return;
      // メーカー絞り込みを解除して全件表示
      if (state.currentMakerFilter) {
        state.currentMakerFilter = null;
        renderLineup();
        updateActiveFilterTag();
      }
      // 少し遅延して該当カードへスクロール + 強調
      setTimeout(() => {
        const target = document.querySelector(`.lineup-card[data-product-no="${no}"]`);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.classList.add('is-highlighted');
          setTimeout(() => target.classList.remove('is-highlighted'), 2400);
        }
      }, 200);
    });
  }

  // ------------------------------------------------------------------------
  // Phase 3D 議事録反映 A1: 販売完了表示（C方式：JS リアルタイム取得）
  //   - DOMContentLoaded 後、対象カード（[data-product-no]）の handle を集めて
  //     `/products/<handle>.js` 公開エンドポイントを並列 fetch
  //   - レスポンスの variants[].available のいずれも false なら売り切れ判定
  //   - 該当カードに .is-sold-out を付与（CSS で「販売完了」バッジ + 価格 line-through）
  //   - クリック先は Shopify 商品ページのまま（暗黙的導線、Sold out 表示に任せる）
  //   - フェッチエラー時は販売中扱い、console.warn のみ（カード非表示にしない）
  //
  // 対象セレクタ：
  //   - S5 lineup の .lineup-card（renderLineupCard で data-product-handle 付与済み）
  //   - S7 gift の .gift-product（HTML 直書きの data-product-no しかないので JS で handle 補完）
  // ------------------------------------------------------------------------
  async function initSoldOutCheck() {
    if (typeof window.fetch !== 'function') return;  // 古い環境のフォールバック
    if (typeof PRODUCTS_DATA !== 'object' || PRODUCTS_DATA === null) return;

    // 全カード要素を取得（S5 lineup は dynamic レンダ後、S7 gift は HTML 直書き）
    const cards = Array.from(document.querySelectorAll('[data-product-no]'));
    if (cards.length === 0) return;

    // data-product-handle が無いカード（S7 gift）には PRODUCTS_DATA から handle を補完
    cards.forEach(el => {
      if (!el.dataset.productHandle) {
        const no = el.dataset.productNo;
        const product = PRODUCTS_DATA[no];
        if (product && product.handle) {
          el.dataset.productHandle = product.handle;
        }
      }
    });

    // ユニークな handle のリスト
    const handles = Array.from(new Set(
      cards.map(el => el.dataset.productHandle).filter(Boolean)
    ));
    if (handles.length === 0) return;

    // /products/<handle>.js を並列 fetch
    const availability = {};
    const results = await Promise.allSettled(
      handles.map(async (handle) => {
        try {
          const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
          if (!res.ok) throw new Error('HTTP ' + res.status);
          const data = await res.json();
          const anyAvailable = Array.isArray(data.variants)
            && data.variants.some(v => v && v.available === true);
          return { handle: handle, available: anyAvailable };
        } catch (err) {
          console.warn('[sold-out check] ' + handle + ': ' + (err && err.message ? err.message : err));
          return { handle: handle, available: true };  // フォールバック：販売中扱い
        }
      })
    );
    results.forEach(r => {
      if (r.status === 'fulfilled' && r.value) {
        availability[r.value.handle] = r.value.available;
      }
    });

    // 該当カードに .is-sold-out クラスを付与
    cards.forEach(el => {
      const handle = el.dataset.productHandle;
      if (handle && availability[handle] === false) {
        el.classList.add('is-sold-out');
      }
    });
  }

  // ------------------------------------------------------------------------
  // 起動
  // ------------------------------------------------------------------------
  ready(() => {
    applyFV();
    initFollowNavVisibility();
    initFollowNavToggle();
    initFollowNavCollapse();
    renderFollowNavMakers();
    renderFollowNavProducts();
    initFollowNavBack();
    initActiveSectionObserver();
    initFadeIn();
    initLineupFilters();
    initMakerJump();
    initProductJump();
    initTypingHeadline();
    initRevealUp();
    initParallaxBg();
    initVoicePhotoPlaceholders();
    // Phase 3D 議事録反映 A1: 販売完了表示（S5 lineup 描画後に実行）
    initSoldOutCheck();
  });

})();

// ===== INTERACTIVE LOGIC END =====

